import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { SimpleSelect as Select } from "../../core/inputs";

import Api from "../../services/Api";
import {
  fetchOrganizations,
  setSelectedOrganizationId
} from "../../redux/Organizations/actions";
import { unexpectedErrorToast } from "../../utils/unexpectedErrorToast";
import { decidedRoute } from "../../core/utils";

function LinkOrganization() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [organizations, setOrganizations] = useState([]);
  const [currentOrganization, setCurrentOrganization] = useState(null);

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const orgs = await Api.organizationsToJoin();
        setOrganizations(orgs);
        if (orgs.length > 0) {
          setCurrentOrganization(orgs[0]);
        }
      } catch (error) {
        unexpectedErrorToast({
          message: (
            <>
              <p>Error fetching organizations.</p>
              <p>Please try again later.</p>
            </>
          )
        });
      }
    };
    fetchOrganizations();
  }, []);

  const handleJoinOrg = async () => {
    if (currentOrganization) {
      try {
        const currentOrganizationId = parseInt(currentOrganization.id);
        const response = await Api.joinOrganization({
          organizationId: currentOrganizationId
        });

        if (response && response.ok) {
          await dispatch(fetchOrganizations());
          await dispatch(setSelectedOrganizationId(currentOrganizationId));
          navigate("/");
        } else {
          unexpectedErrorToast({
            message: (
              <>
                <p>Failed to join organization.</p>
                <p>Please try again later.</p>
              </>
            )
          });
        }
      } catch (error) {
        unexpectedErrorToast({
          message: (
            <>
              <p>Error joining organization.</p>
              <p>Please try again later.</p>
            </>
          )
        });
      }
    }
  };

  const handleOnSelectOrganization = (selectedOrg) => {
    setCurrentOrganization(selectedOrg);
  };

  return (
    <div className="flex flex-1 flex-col items-center justify-start py-20 min-h-screen bg-white">
      <div className="flex flex-col w-1/2 items-center text-center">
        <h1 className="text-primary-blue font-bold text-3xl">
          It looks like you are a member of an existing organization but aren’t
          using the Advisor app yet.
        </h1>
        <p className="my-4 font-bold text-lg w-2/3">
          You can invite additional users to your organization anytime from your
          organization settings page.
        </p>
        <div className="flex flex-row items-center justify-center w-2/3 my-4">
          <span className="text-primary-blue font-bold">
            Which organization would you like to use the Advisor app with?
          </span>
        </div>
        <div className="flex flex-row items-center justify-center w-2/4 my-4">
          <Select
            placeholder="Select organization"
            list={organizations}
            current={currentOrganization?.name}
            onSelect={handleOnSelectOrganization}
          />
        </div>
        <button
          className="
            w-1/3 
            h-14 
            mt-4 
            mb-4
            bg-primary-blue 
            text-white 
            font-bold 
            px-4 
            py-2 
            hover:drop-shadow-md"
          onClick={handleJoinOrg}
        >
          Sign Up
        </button>
        <p className="text-sm text-center w-1/4 text-wrap ">
          <span>
            By signing up you agree to our
            <br />
          </span>
          <a
            className="underline cursor-pointer"
            href={decidedRoute("/legal/terms-of-service/")}
          >
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            className="underline cursor-pointer"
            href={decidedRoute("/legal/privacy-policy/")}
          >
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
}

export default LinkOrganization;
